import {
    datesOver30Filter,
    datesOverFilter,
    over30days,
    overXDays
} from 'application/Shared/Components/Cells';
import {
    CellType,
    ColumnBuilder
} from 'application/Shared/Components/Table/types';
import { TenantLicenseUsage } from 'application/Shared/types/tenantLicenseUsage';
import { t } from 'i18next';

// Possibly move this into a config file so new metadata can be added/updated
// on the fly
export const LICENSE_METADATA_COLUMNS: ColumnBuilder<TenantLicenseUsage>[] = [
    {
        cellType: CellType.DateFormat,
        enableColumnFilter: true,
        filterFn: overXDays,
        headerIcon: {
            src: 'WarningTriangleFilled',
            tooltipText: 'SaasOps.licenses.notProvided',
            variant: 'warningDark'
        },
        id: 'lastLoginTime',
        meta: { filter: datesOverFilter },
        name: 'Common.lastLoginTime',
        positionFromEnd: 2,
        property: 'metadata.lastLoginTime',
        props: {
            noTz: false
        },
        size: 300,
        sortingFn: 'datetime',
        testId: 'lastLoginTime'
    },
    {
        cellType: CellType.Icon,
        enableColumnFilter: true,
        filterFn: over30days,
        id: 'lastLoginTimeOver30daysAgo',
        meta: { filter: datesOver30Filter },
        name: 'Common.underutilized',
        positionFromEnd: 2,
        property: 'metadata.lastLoginTime',
        props: {
            iconCellProps: {
                src: 'Clock',
                tooltipText: t('Common.lastLogin', {
                    days: 30
                }),
                variant: 'danger'
            }
        },
        size: 300,
        sortingFn: 'datetime', // TODO
        testId: 'lastLoginTimeOver30daysAgo'
    }
    // The following columns will be added in the future to recipes. Once they are added,
    // we can uncomment the columns and display the data.
    // {
    //     cellType: CellType.String,
    //     enableColumnFilter: false,
    //     headerIcon: {
    //         src: 'WarningTriangleFilled',
    //         tooltipText: 'SaasOps.licenses.notProvided',
    //         variant: 'warningDark'
    //     },
    //     id: 'mfa',
    //     name: 'Common.mfa',
    //     positionFromEnd: 1,
    //     property: 'metadata.mfa',
    //     size: 300,
    //     testId: 'mfa'
    // },
    // {
    //     cellType: CellType.String,
    //     enableColumnFilter: false,
    //     headerIcon: {
    //         src: 'WarningTriangleFilled',
    //         tooltipText: 'SaasOps.licenses.notProvided',
    //         variant: 'warningDark'
    //     },
    //     id: 'role',
    //     name: 'Users.role',
    //     positionFromEnd: 1,
    //     property: 'metadata.role',
    //     size: 300,
    //     testId: 'role'
    // }
];
